import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import ExitToApp from '@material-ui/icons/ExitToApp';

const useStyles = makeStyles(theme => ({
    compactButton: {
        minWidth: 0,
        padding: theme.spacing(0.35),
        borderRadius: 999,
        color: theme.palette.getContrastText(theme.palette.primary.main),
        backgroundColor: 'rgba(15, 23, 42, 0.12)',
        "&:hover": {
            backgroundColor: 'rgba(15, 23, 42, 0.2)',
        },
    },
    button: {
        color: theme.palette.getContrastText(theme.palette.primary.main),
        textTransform: 'none',
        padding: theme.spacing(0.75, 1.5),
        borderRadius: 999,
        backgroundColor: 'rgba(15, 23, 42, 0.08)',
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: 'rgba(15, 23, 42, 0.16)',
            transform: 'translateY(-1px)',
        },
    },
    avatar: {
        height: 32,
        width: 32,
        fontSize: 14,
        marginRight: theme.spacing(1),
        backgroundColor: theme.palette.grey[900],
        color: theme.palette.common.white,
        boxShadow: '0 6px 14px rgba(15, 23, 42, 0.18)',
    },
    compactAvatar: {
        marginRight: 0,
    },
    menuPaper: {
        borderRadius: 16,
        minWidth: 220,
        padding: theme.spacing(1),
        boxShadow: '0 18px 36px rgba(15, 23, 42, 0.25)',
    },
    menuHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1, 1.5),
    },
    menuAvatar: {
        height: 40,
        width: 40,
        fontSize: 16,
        backgroundColor: theme.palette.grey[900],
        color: theme.palette.common.white,
    },
    menuItem: {
        borderRadius: 12,
        marginTop: theme.spacing(0.5),
    },
    name: {
        fontWeight: 600,
    },
    subtitle: {
        color: theme.palette.text.secondary,
        fontSize: 12,
    },
}));

const AccountButton = ({ firstName, dispatch, compact = false }) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const initial = firstName ? firstName[0].toUpperCase() : '?';

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        dispatch({ type: 'LOGOUT' });
        handleClose();
    };

    return (
        <>
            <Button
                aria-controls="account-menu"
                aria-haspopup="true"
                aria-label="User Profile Icon"
                onClick={handleClick}
                className={compact ? classes.compactButton : classes.button}
                startIcon={compact ? null : <Avatar className={classes.avatar}>{initial}</Avatar>}
            >
                {compact ? <Avatar className={`${classes.avatar} ${classes.compactAvatar}`}>{initial}</Avatar> : firstName}
            </Button>
            <Menu
                id="account-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                classes={{ paper: classes.menuPaper }}
            >
                <Box className={classes.menuHeader}>
                    <Avatar className={classes.menuAvatar}>{initial}</Avatar>
                    <Box>
                        <Typography variant="subtitle1" className={classes.name}>
                            {firstName}
                        </Typography>
                        <Typography className={classes.subtitle}>Signed in</Typography>
                    </Box>
                </Box>
                <Divider />
                <MenuItem onClick={handleLogout} className={classes.menuItem}>
                    <ExitToApp fontSize="small" style={{ marginRight: 8 }} />
                    Log out
                </MenuItem>
            </Menu>
        </>
    );
}

export default connect()(AccountButton);
